export default __webpack_public_path__ + "images/12705c5d096954d2fe18a2ed1827db4d-video-loading.png";